export function getInitials(displayName: string): string {
    return displayName
        .split(/\s+/)
        .map(token => token[0] ?? "")
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();
}
